export const pillars = ['Hangeul', 'Pronuncia', 'Vocabolario', 'Routine'];
export const volumes = [{
  n: 1,
  emoji: '🧩',
  title: 'Il Codice Hangeul: Leggere senza fatica',
  desc: "Impara le 24 lettere fondamentali con il Metodo SIGMA SMART - visivo, istantaneо, indimenticabile.",
  points: ['Le 24 lettere base spiegate con associazioni visive', 'Come combinare consonanti e vocali in blocchi sillabici', 'Esercizi di scrittura rapida per memorizzare l’alfabeto']
}, {
  n: 2,
  emoji: '🎤',
  title: 'Fonetica Perfect Pitch',
  desc: "I segreti sonori del coreano spiegati con\nequivalenze italiane : suona come\nun vero abitante di Seoul.",
  points: ['La chiave segreta delle doppie consonanti', 'Regole di assimilazione: si scrive così, si pronuncia diversamente', 'Come evitare l’accento italiano e suonare come un nativo di Seoul']
}, {
  n: 3,
  emoji: '🗣️',
  title: 'Il Dizionario K-Drama',
  desc: "Le 100 parole del cuore: amore, amicizia,\nlavoro, con le espressioni che i traduttori\nautomatici sbagliano sempre.",
  points: ['Le 100 parole più usate in amore, amicizia e lavoro', 'Espressioni idiomatiche che i traduttori automatici sbagliano sempre', 'Il linguaggio del corpo coreano che accompagna le parole']
}, {
  n: 4,
  emoji: '📅',
  title: 'Grammatica Espresso: Frasi Reali',
  desc: "La struttura Soggetto-Oggetto-Verbo\nspiegata come un treno: i vagoni\nvanno sempre in ordine.",
  points: ['La struttura Soggetto-Oggetto-Verbo spiegata semplicemente', 'Le particelle base (ne/eun, i/ga) senza mal di testa', 'Presente, Passato e Futuro: il minimo indispensabile per farti capire']
}, {
  n: 5,
  emoji: '🎬',
  title: 'K-Pop & Cultura Social',
  desc: "Il coreano che si usa davvero su Instagram,\nTikTok e nei commenti ai tuoi idol preferiti.",
  points: ['Decodifica dei testi delle canzoni più famose', 'Come allenare l’orecchio mentre guardi Netflix', 'Lo slang di Internet (JMT, OOTD coreano) per i social coreani']
}, {
  n: 6,
  emoji: '💬',
  title: 'Routine 60 Minuti e Prossimi Passi',
  desc: "II Metodo Sigma Smart: come trasformare 60 minuti al giorno in progressi reali e misurabili.",
  points: ['Il piano d’azione per trasformare 60 minuti al giorno in fluidità', 'Risorse gratuite segrete per continuare a praticare', 'Conclusione e cerimonia di "Diploma" virtuale']
}];
export const volumeIncludes = ['Lezioni visive passo a passo', 'Romanizzazione + traduzione', 'Esercizi di pronuncia', 'Esempi reali dai K-Drama', 'Checklist di pratica quotidiana', 'Schede di verifica stampabili', 'Pensato per principianti assoluti', 'Pronto da applicare oggi'];
export const bonuses = [{
  n: '01',
  title: '📖 Dizionario Visivo K-Food: Mangia come a Seoul',
  desc: "Il Dizionario Visivo K-Food:\xA0In 15 card imparerai non solo cosa mangiare, ma come farlo da vero locale.",
  price: '27€',
  img: 'https://cdn.magicpatterns.com/uploads/kAg2HMTRM3f9mNfHeN4rEn/ChatGPT_Image_9_sept_2026,_18_19_21.png'
}, {
  n: '02',
  title: '🎯 Cheat-Sheet: 100 Frasi per il tuo IDOL',
  desc: "Le 100 FrasiIndispensabili per farti notare sui\nSocial e ai Concerti\nSmetti di essere un fan qualunque. Impara il coreano che i tuoi idol capiscono e apprezzano.",
  price: '24€',
  img: 'https://cdn.magicpatterns.com/uploads/aent41LXSNwfKyXTDhZFja/ChatGPT_Image_9_sept_2026,_18_19_18.png'
}, {
  n: '03',
  title: '🎧 Seoul Express: Guida Turistica di Sopravvivenza',
  desc: "La Guida Turistica di Sopravvivenza\nMuoviti in Corea come un locale. Tutto ciò che i tour operator non ti dicono.",
  price: '21€',
  img: 'https://cdn.magicpatterns.com/uploads/nKDEAieemZdgMTeYtmw7Y2/ChatGPT_Image_9_sept_2026,_18_19_16.png'
}, {
  n: '04',
  title: '🎬 Flashcards Stampabili: Hangeul Flash-Master',
  desc: "Il set di Flashcards definitivo per\ndominare l'alfabeto coreano in tempo record\nStampa Ritaglia Memorizza",
  price: '25€',
  img: 'https://cdn.magicpatterns.com/uploads/ravNvkBQZv67XmLoJWn9Qd/ChatGPT_Image_9_sept_2026,_18_19_10.png'
}, {
  n: '05',
  title: '📊 Workbook di Scrittura: Il Mio Primo Diario Coreano',
  desc: "Dalla prima lettera alla tua prima pagina di diario. Un percorso visivo,\npratico e bellissimo per imparare a scrivere in Hangul, passo dopo passo.",
  price: '19€',
  img: 'https://cdn.magicpatterns.com/uploads/6UKpsZz4PKkEcUeCVMgk8h/ChatGPT_Image_9_sept_2026,_18_19_08.png'
}];